import {
  CreateFormTemplateFieldGroupRequest,
  CreateFormTemplateFieldRequest,
  FormTemplateFieldConditionalRule,
  FormTemplateFieldGroupResponse,
  FormTemplateFieldResponse,
  FormTemplateFieldTypes,
  FormTemplateResponse,
  NonEmptyArray,
} from 'mapistry-shared';

export type FieldGroupSlug = string;

type FormTemplateSectionFieldType = {
  id: string;
  name: string;
  type: FormTemplateFieldTypes;
};

export type FormTemplateSectionType = {
  name: string;
  isActive: boolean;
  isDuplicable?: boolean;
  fields?: FormTemplateSectionFieldType[];
  clickHandler?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

// ID will be generated on field creation, but use this type before then
export type CreateFormTemplateFieldRequestValues = Omit<
  CreateFormTemplateFieldRequest,
  'id'
>;

export type CreateFormTemplateFieldGroupFormValues = Pick<
  CreateFormTemplateFieldGroupRequest,
  'name' | 'isDuplicable' | 'isStencilProtected'
>;

export type UpdateFormTemplateFieldGroupFormValues =
  CreateFormTemplateFieldGroupFormValues;

// This type allows the fields from the full form template response data
// to be shown alongside newly created fields during editing
export type EditableFormTemplateField =
  | FormTemplateFieldResponse
  | CreateFormTemplateFieldRequest;

export type TriggerField = EditableFormTemplateField & {
  conditionalRules: NonEmptyArray<FormTemplateFieldConditionalRule>;
};

export const isTriggerField = (
  field: EditableFormTemplateField,
): field is TriggerField => !!field.conditionalRules?.length;

export type EditableFormTemplateFieldGroup =
  | CreateFormTemplateFieldGroupRequest
  | (Omit<FormTemplateFieldGroupResponse, 'fields'> & {
      fields: EditableFormTemplateField[];
    });

export type EditableFormTemplate = Omit<FormTemplateResponse, 'groups'> & {
  groups: EditableFormTemplateFieldGroup[];
} & { id: string };

/** For cases where you also need the group that the field belongs to */
export interface FieldWithGroupSlug {
  field: EditableFormTemplateField;
  groupSlug: string;
}
